import { setWordPressGlobal } from './initWordPress';
let isWordPressCache;
export function clearIsWordPressCacheForTests() {
  isWordPressCache = undefined;
  window.hubspot = Object.assign({}, window.hubspot, {
    wordpress: undefined
  });
}
export default function checkIfWordPress() {
  if (typeof isWordPressCache === 'undefined') {
    isWordPressCache = setWordPressGlobal();
  }
  return isWordPressCache;
}